import { render } from "./DefaultFooter.vue?vue&type=template&id=aed6b224&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"

import "./DefaultFooter.vue?vue&type=style&index=0&id=aed6b224&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed6b224"]])

export default __exports__